import React from 'react';
import CSVVerifier from '../components/CSVVerifier';

const CSVVerifierPage = () => {
  return <CSVVerifier />;
};

export default CSVVerifierPage;
